import { useState } from 'react';

import PropTypes from 'prop-types';
import { BsCloudUpload } from 'react-icons/bs';

import Alert from '#globalComponents/Alert/Alert';
import Button from '#globalComponents/Button/Button';
import Card from '#globalComponents/Card/Card';

import ImportLauncher from '../../../components/import/ImportLauncher';

const ImportSettingsTab = () => {
	const [showWizard, setShowWizard] = useState(false);

	return (
		<Card className="p-6">
			<div className="flex items-start justify-between gap-4">
				<div>
					<h2 className="text-lg font-semibold text-text">Daten importieren</h2>
					<p className="text-sm text-bgBase-800 mt-1">
						Importieren Sie Kontakte und Firmen aus einer CSV-Datei – oder migrieren Sie Ihren gesamten
						Pipedrive-Export (inkl. Deals, Aktivitäten und Notizen).
					</p>
				</div>
				<Button className="shrink-0" onClick={() => setShowWizard(true)}>
					<BsCloudUpload className="w-4 h-4 mr-2" />
					Import starten
				</Button>
			</div>

			<div className="mt-6 grid grid-cols-2 gap-4">
				<InfoCard
					title="CSV-Datei"
					description="Kontakt- und Firmenspalten in einer Datei (z. B. Vorname, E-Mail, Firmenname, Website)"
				/>
				<InfoCard
					title="Pipedrive-Migration"
					description="Alle Pipedrive-Exporte auf einmal: Organisationen, Personen, Deals, Aktivitäten, Notizen"
				/>
			</div>

			<Alert tone="info" title="Hinweis zum Import" className="mt-6">
				<ul className="text-xs space-y-1 list-disc list-inside">
					<li>Maximal 10.000 Zeilen pro Import</li>
					<li>Spalten werden automatisch erkannt und zugeordnet</li>
					<li>Modus wählbar: nur neue anlegen, nur bestehende aktualisieren, oder beides</li>
					<li>Beim Aktualisieren werden nur leere Felder ergänzt</li>
				</ul>
			</Alert>

			<ImportLauncher isOpen={showWizard} onClose={() => setShowWizard(false)} />
		</Card>
	);
};

function InfoCard({ title, description }) {
	return (
		<Card>
			<h3 className="text-sm font-semibold text-text">{title}</h3>
			<p className="text-xs text-bgBase-800 mt-1">{description}</p>
		</Card>
	);
}

InfoCard.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
};

export default ImportSettingsTab;
